import { render, staticRenderFns } from "./merchant-closed.vue?vue&type=template&id=a5507bfe&scoped=true"
import script from "./merchant-closed.vue?vue&type=script&lang=js"
export * from "./merchant-closed.vue?vue&type=script&lang=js"
import style0 from "./merchant-closed.vue?vue&type=style&index=0&id=a5507bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5507bfe",
  null
  
)

export default component.exports